// Flutterwave Configuration
export const FLUTTERWAVE_CONFIG = {
  // Test keys - Replace with production keys when deploying
  publicKey: process.env.REACT_APP_FLUTTERWAVE_PUBLIC_KEY || 'FLWPUBK-9cc7e0bdc12456c9764a0e957b15a9d5-X',
  secretKey: process.env.REACT_APP_FLUTTERWAVE_SECRET_KEY || 'FLWSECK-6f8674dc27e338318736079eed9e5472-198af94e76dvt-X',
  // publicKey: process.env.REACT_APP_FLUTTERWAVE_PUBLIC_KEY || 'FLWPUBK_TEST-328a6cc27c2428a761cd5cf019ee82b8-X',
  // secretKey: process.env.REACT_APP_FLUTTERWAVE_SECRET_KEY || 'FLWSECK_TEST-2740ec906787a04697e9610e1976740b-X',
  // API Configuration
  baseUrl: process.env.REACT_APP_FLUTTERWAVE_BASE_URL || 'https://api.flutterwave.com/v3',
  
  // Redirect URLs
  redirectUrl: process.env.REACT_APP_FLUTTERWAVE_REDIRECT_URL || 'http://localhost:3000/app/payment-success',
  
  // IPN (Instant Payment Notification) URL
  // For local testing, use: http://127.0.0.1:5001/profstudymate/us-central1/flutterwaveIPN/flutterwave-ipn
  // For production, use: https://your-project.cloudfunctions.net/flutterwaveIPN/flutterwave-ipn
  ipnUrl: process.env.REACT_APP_FLUTTERWAVE_IPN_URL || 'https://flutterwaveipn-ew5jz6h7wq-uc.a.run.app/flutterwaveIPN/flutterwave-ipn',
  
  // App Configuration
  appName: process.env.REACT_APP_APP_NAME || 'ProfStudymate',
  appUrl: process.env.REACT_APP_APP_URL || 'http://localhost:3000',
  
  // Support Information
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'profstrainingsolutions@gmail.com',
  
  // Currency and Country Settings (Ghana only)
  defaultCurrency: 'GHS',
  defaultCountry: 'GH',
  
  // Payment Methods
  supportedPaymentMethods: ['card', 'mobile_money', 'bank_transfer'],
  
  // Logo and Branding
  logoUrl: 'https://profstudymateadmin.com/images/icon.png',
  
  // Environment
  environment: process.env.NODE_ENV || 'development',
  isTestMode: process.env.NODE_ENV !== 'production',
};

// Payment Method Configuration
export const PAYMENT_METHODS = {
  card: {
    name: 'Credit/Debit Card',
    description: 'Pay with Visa, Mastercard, or any international card',
    icon: '💳',
    processingTime: 'Instant',
    fees: 0,
    isActive: true,
  },
  mobile_money: {
    name: 'Mobile Money',
    description: 'Pay with MTN Mobile Money, Vodafone Cash, or Airtel Money',
    icon: '📱',
    processingTime: 'Instant',
    fees: 0,
    isActive: true,
  },
  bank_transfer: {
    name: 'Bank Transfer',
    description: 'Direct bank transfer to our account',
    icon: '🏦',
    processingTime: '1-3 business days',
    fees: 0,
    isActive: true,
  },
  offline: {
    name: 'Offline Payment',
    description: 'Pay directly to our accounts and notify us',
    icon: '💸',
    processingTime: '1-24 hours (after verification)',
    fees: 0,
    isActive: true,
  },
};

// Ghana Mobile Money Providers
export const MOBILE_MONEY_PROVIDERS = [
  {
    code: 'MTN',
    name: 'MTN Mobile Money',
    icon: '📱',
    isActive: true,
  },
  {
    code: 'VODAFONE',
    name: 'Vodafone Cash',
    icon: '📱',
    isActive: true,
  },
  {
    code: 'AIRTEL',
    name: 'Airtel Money',
    icon: '📱',
    isActive: true,
  },
];

// Ghanaian Cities for Address Form
export const GHANAIAN_CITIES = [
  'Accra',
  'Kumasi',
  'Tamale',
  'Sekondi-Takoradi',
  'Ashaiman',
  'Sunyani',
  'Cape Coast',
  'Obuasi',
  'Teshie',
  'Tema',
  'Madina',
  'Koforidua',
  'Wa',
  'Ho',
  'Bolgatanga',
  'Other',
];

// Ghanaian Regions
export const GHANAIAN_REGIONS = [
  'Greater Accra',
  'Ashanti',
  'Western',
  'Central',
  'Eastern',
  'Northern',
  'Upper East',
  'Upper West',
  'Volta',
  'Bono',
  'Bono East',
  'Ahafo',
  'Savannah',
  'North East',
  'Oti',
  'Western North',
];

// Offline Payment Details
export const OFFLINE_PAYMENT_DETAILS = {
  mtnMobileMoney: {
    name: 'MTN Mobile Money',
    phoneNumber: '0530420138',
    accountName: 'Profs Training Solutions',
    icon: '📱',
    description: 'Send money to MTN Mobile Money number',
  },
  momoPay: {
    name: 'MoMo Pay',
    phoneNumber: '992370',
    accountName: 'Profs Training Solutions',
    icon: '📱',
    description: 'Send money to MoMo Pay number',
  },
  absaBank: {
    name: 'ABSA Bank',
    accountNumber: '0601251779',
    accountName: 'Bill Cobby Impriam',
    icon: '🏦',
    description: 'Transfer to ABSA Bank account',
  },
  whatsappNumber: '+233243443934', // Added Ghana country code (+233)
  whatsappMessage: 'I have made payment for my order. Please verify and grant access.',
};
